import {axiosInstance} from "@/plugins/axios";
import {ExecutionRecordInterface, InterfaceSchedule} from "@/modules/interfaces/types";

export async function getInterfaces() {
    const response = await axiosInstance.get(`interfaces`);
    return response.data;
}

export async function getInterface(id: string) {
    const response = await axiosInstance.get(`interfaces/${id}`);
    return response.data;
}

export async function executeProcurementInterface(fmtPeriod: string[]) {
    await axiosInstance.post(`interfaces/purchases`, {
        start_date: fmtPeriod[0],
        end_date: fmtPeriod[1]
    });
}

export async function executeVendorInterface(fmtPeriod: string[]) {
    await axiosInstance.post(`interfaces/vendor`, {
        start_date: fmtPeriod[0],
        end_date: fmtPeriod[1]
    });
}
export async function executeCustomerInterface(fmtPeriod: string[]) {
    await axiosInstance.post(`interfaces/customer`, {
        start_date: fmtPeriod[0],
        end_date: fmtPeriod[1]
    });
}

export async function executeItemsInterface(fmtPeriod: string[]) {
    await axiosInstance.post(`interfaces/items`, {
        start_date: fmtPeriod[0],
        end_date: fmtPeriod[1]
    });
}

export async function executeNetCostInterface(fmtPeriod: string[]) {
    await axiosInstance.post(`interfaces/net_cost`, {
        start_date: fmtPeriod[0],
        end_date: fmtPeriod[1]
    });
}

export async function executeBOMInterface(fmtPeriod: string[]) {
    await axiosInstance.post(`interfaces/bom`, {
        start_date: fmtPeriod[0],
        end_date: fmtPeriod[1]
    });
}

export async function executeSaleInterface(fmtPeriod: string[]) {
    await axiosInstance.post(`interfaces/sales`, {
        start_date: fmtPeriod[0],
        end_date: fmtPeriod[1]
    });
}

export async function executeExchangeRate(fmtPeriod: string[]) {
    await axiosInstance.post(`interfaces/exchange_rate`, {
        start_date: fmtPeriod[0],
        end_date: fmtPeriod[1]
    });
}

export async function executeCustomerModel(fmtPeriod: string[]) {
    await axiosInstance.post(`interfaces/customer_model`, {
        start_date: fmtPeriod[0],
        end_date: fmtPeriod[1]
    });
}

export async function getExecutionRecords(payload: ExecutionRecordInterface) {
    let url = `interfaces/execution_records`;
    if (payload.id_interface && payload.date) {
        url +=`?id_interface=${payload.id_interface}&start_application_date=${payload.date[0]}&end_application_date=${payload.date[1]}`;
        const response = await axiosInstance.get(url);
        return response.data;
    }
    return [];
}

export async function scheduleInterface(payload: InterfaceSchedule) {
    await axiosInstance.put(`interfaces/${payload.interface_id}`, {
        cron_expression: payload.cron_expression,
        start_date: payload.start_date
    });
}